import { useState, type ReactElement } from "react";
import { EXCLUDED_MARKETS } from "../_stubData.ts";
import { SrIcon } from "./SrIcon.tsx";

interface Props {
  defaultOpen?: boolean;
}

export function ExcludedMarketsCard({ defaultOpen = false }: Props): ReactElement {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <div className="sr-excluded-card">
      <div className="sr-excluded-head">
        <div className="ic">
          <SrIcon name="x" size={14} />
        </div>
        <div>
          <h3>Markets we never suggest — and why</h3>
          <div className="sub">
            {EXCLUDED_MARKETS.length} markets permanently excluded from the catalogue. STRIKZA Intelligence will
            never propose them.
          </div>
        </div>
        <button className="toggle" onClick={() => setOpen(!open)}>
          {open ? "Hide" : `Show all ${EXCLUDED_MARKETS.length}`}
          <SrIcon name={open ? "undo" : "arrow"} size={11} />
        </button>
      </div>
      {open && (
        <div className="sr-excluded-body">
          {EXCLUDED_MARKETS.map((m, i) => (
            <div className="sr-excluded-row" key={i}>
              <div className="mkt">
                <span className="strike">
                  <SrIcon name="x" size={9} />
                </span>
                {m.name}
              </div>
              <div className="why">{m.reason}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
